import { request } from '../request';

export async function getShift(shiftId: string) {
  if (shiftId.startsWith('shiftrotation-')) {
    return getShiftRotation(shiftId);
  }
  if (shiftId.startsWith('shiftseries-')) {
    return getShiftSeries(shiftId);
  }
  throw new Error('TBD: request for the single shift is not implemented');
}
export async function getShiftSeries(shiftId: string) {
  // id: shiftseries-00000000000000000000000000
  return request.get<ShiftRotationResponse>(`/v2/shift-series/${shiftId}`);
}

export async function getShiftRotation(shiftId: string) {
  // id: shiftrotation-00000000000000000000000000
  return request.get<ShiftSeriesResponse>(`/v2/shift-rotations/${shiftId}`);
}

type ShiftRotationResponse = ShiftPeriodicResponse;
type ShiftSeriesResponse = ShiftPeriodicResponse;
type ShiftPeriodicResponse = {
  id: string;
  externalId: string;
  agenciesForShare: {
    id: string; //'staffingpartner-00000000000000000000000000';
    logoURL: string;
    name: string;
    tenantId: string;
  }[];
  assignRequest: {
    status: 'Pending' | 'Approved' | 'Declined';
    staff: {
      id: string;
      avatar: string;
      firstName: string;
      lastName: string;
      name: string;
      isInternal: true;
      agencyId: string; //'agency-00000000000000000000000000';
      agencyName: string;
      orientedList: [
        {
          locationId: string; //'location-00000000000000000000000000';
          oriented: boolean;
        },
      ];
    };
    declineReason: string;
  };
  status: Status;
  isArchive: boolean;
  isShared: boolean;
  isPublished: boolean;
  isAssigned: boolean;
  isTerminated: boolean;
  canShare: boolean;
  canAssign: boolean;
  canUnassign: boolean;
  staffingType: 'All' | 'Internal' | 'External';
  staffNurseQualificationFilters: {
    id: string;
    name: string;
    abbreviation: string;
    category: string;
  }[];
  staff: {
    id: string;
    firstName: string;
    lastName: string;
    imageURL: string;
    nurseQualifications: {
      id: string;
      name: string;
      abbreviation: string;
      category: string;
    }[];
  }[];
  startDate: {
    dateTime: string;
    timeZone: string;
  };
  endDate: {
    dateTime: string;
    timeZone: string;
  };
  department: {
    id: string;
    label: string;
  };
  subDepartment: {
    id: string;
    label: string;
  } | null;
  speciality: {
    id: string;
    title: string;
    category: string;
  };
  events: {
    id: string;
    startDate: {
      dateTime: string;
      timeZone: string;
    };
    endDate: {
      dateTime: string;
      timeZone: string;
    };
    status: Status;
    staff: {
      id: string;
      firstName: string;
      lastName: string;
      imageURL: string;
    } | null;
    qualifications: {
      id: string;
      name: string;
      abbreviation: string;
      category: string;
    }[];
  }[];
  locationId: string;
  tags: string[] | null;
  note: string | null;
  isUrgent: boolean;
  canHasMultipleAssignee: boolean;
};

type Status =
  | 'Opened'
  | 'Pending'
  | 'Assigned'
  | 'Reassigned'
  | 'Canceled'
  | 'InProgress'
  | 'Unfilled'
  | 'Deleted'
  | 'Expired'
  | 'Unassigned'
  | 'Completed';
